import ManageBilanSante from '@/views/parametres/configs/param-bilan-sante/manage-bilan-sante'
import ExcelModal from '@/views/parametres/import-excel-modal'
import $ from 'jquery'
import listesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

export default {
    name: 'param-bilan-sante',
    components: {
        ManageBilanSante, ExcelModal
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            fields: [
				{ key: 'prestation', label: 'Prestation' }, 'composition', { key: 'actions', label: 'Action.s' }
			],
            // Page courante (pagination et recherche côté serveur, données locales au composant)
            bilans: nouvelleListe(),

            is_edit: false,

            save_loading: false,
            modal_title: 'Nouveau bilan de santé',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            bilan_to_edit: {},

            is_printing: false,
            filename: '',
            modal_toggler: true,

            type_admission: '',
            designation: '',
            emit_action: '',

            bilan_fields: {
                'Libellé': 'libelle',
                'Analyses': 'l_analyses',
                'Examens': 'l_examens',
                'Prix': 'prix'
            },

            bilan_filename: 'Liste_Bilan_Sante.xls',

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        this.getListeBilanSante()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_bilan_sante_'+tmpstamp
    },

    methods: {
        /**
         * Recherche côté serveur après la saisie (retour à la page 1)
         */
        rechercher(liste, charger) {
            rechercherDiffere(liste, charger)
        },

        addPrestation() {
            this.modal_title = 'Nouveau bilan de santé'
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        bilan_composition(prestations, type_prestation) {
            let composition = ''

            let separator = ''
            if (prestations && prestations.length > 0) {
                prestations.forEach((prestation, i) => {
                    separator = ', '
                    if (i == prestations.length-1) {
                        separator = ''
                    }
                    if (type_prestation == 'analyse') {
                        composition += prestation.analyse+separator
                    } else {
                        composition += prestation.examen+separator
                    }
                });
            }

            return composition
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeBilanSante() {
            this.is_loading = true
            this.can_view_percentage = true
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            if (this.bilans.total > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getListeBilanSante()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getListeBilanSante()
            this.c_refresh_timeout_id = setTimeout(() => {
                this.refreshListeBilanSante()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeBilanSante()
        },

        /**
         * Recharge la page courante (après ajout, modification, suppression, import)
         */
        getListeBilanSante() {
            return chargerPage(this.bilans, params => listesPaginees.bilansSante(params)).then(() => {
                if (this.bilans.chargement) {
                    // Réponse périmée : une requête plus récente est en cours
                    return
                }

                // Catalogue vide (hors recherche) : message « Aucune donnée disponible »
                this.is_empty = !this.bilans.erreur && this.bilans.total == 0 && this.bilans.q == ''

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.is_loading = false
                    }
                } else {
                    this.is_loading = false
                }
            })
        },

        edit(bilan) {
            this.modal_title = 'Modifier'
            this.bilan_to_edit = bilan
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        setToDelete(c) {
            this.to_be_deleted = {
                id: c.id,
                libelle: c.libelle
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteBilanSante', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Bilan de santé supprimé avec succès")
                    this.getListeBilanSante()

                    this.is_confirm = false
                    this.$refs.delBilan.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },

        handleBeforeGenerateBilanSante() {
            let d = new Date()
            this.bilan_filename = 'Liste_Bilan_Sante_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitBilanSante'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);       
        },

        /**
         * Export Excel : la liste complète est chargée au clic
         * (prop `fetch` de export-excel, appelée après before-generate)
         */
        fetchExportBilanSante() {
            return listesPaginees.bilansSante().then((bilans) => {
                const lignes = (bilans || []).map(bilan => {
                    let comp_analyses = ''
                    let comp_examens = ''
                    if (Object.prototype.hasOwnProperty.call(bilan, 'analyses')) {
                        comp_analyses = this.bilan_composition(bilan.analyses, 'analyse')
                    }
                    if (Object.prototype.hasOwnProperty.call(bilan, 'examens')) {
                        comp_examens = this.bilan_composition(bilan.examens, 'examen')
                    }

                    return {
                        'libelle': bilan.libelle,
                        'l_analyses' : comp_analyses,
                        'l_examens': comp_examens,
                        'prix' : (bilan.prix > 0)?bilan.prix:''
                    }
                })

                if (lignes.length == 0) {
                    // Rien à exporter : export-excel s'arrête sans appeler before-finish
                    this.is_exporting = false
                }
                return lignes
            }).catch(() => {
                this.is_exporting = false
                this.errorToast("Impossible de préparer l'export. Merci de réessayer.")
                return []
            })
        },

        printBilanSante() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            // Impression de la liste complète, chargée au clic
            listesPaginees.bilansSante().then((bilans) => {
                const data = {
                    data_type: 'bilan_sante',
                    prestations: bilans || []
                }
                this.$emit('emitTriggerPrint', data)
            }).catch(() => {
                this.errorToast("Impossible de charger la liste à imprimer. Merci de réessayer.")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}